import React from "react";
import { Button, ButtonProps, Flex, Text } from "@chakra-ui/react";
import CustomIcon, { AssetTypes } from "../../../../../../public/icons-v1_1";

interface InfoSectionBtnProps extends ButtonProps {
  children: React.ReactNode;
  leadingIconSrc?: AssetTypes;
  trailingIconSrc?: AssetTypes;
}

function OrderHistoryButton({
  children,
  leadingIconSrc,
  trailingIconSrc,
  ...props
}: InfoSectionBtnProps) {
  return (
    <Button
      padding={"4px 8px"}
      boxShadow={"0 0 0 0.5px #8F8F8C, 0 2px 4px 0 rgba(0, 0, 0, 0.10)"}
      borderRadius={"4px"}
      border={"none"}
      background={"#FCFCFB"}
      height={"28px"}
      {...props}
    >
      <Flex gap={"4px"} alignItems={"center"}>
        {leadingIconSrc && (
          <CustomIcon
            src={leadingIconSrc}
            width={16}
            height={16}
            color={"#8F8F8C"}
          />
        )}
        <Text textStyle={"body-sm-bold"} color={"#444444"}>
          {children}
        </Text>
        {trailingIconSrc && (
          <CustomIcon
            src={trailingIconSrc}
            width={16}
            height={16}
            color={"#8F8F8C"}
          />
        )}
      </Flex>
    </Button>
  );
}

export default OrderHistoryButton;
